// ---------------- Grant Application ----------------

export const FETCH_COUNTRIES = "FETCH_COUNTRIES";
export const FETCH_COUNTRIES_SUCCEEDED = "FETCH_COUNTRIES_SUCCEEDED";
export const FETCH_COUNTRIES_FAILED = "FETCH_COUNTRIES_FAILED";

export const FETCH_COUNTIES = "FETCH_COUNTIES";
export const FETCH_COUNTIES_SUCCEEDED = "FETCH_COUNTIES_SUCCEEDED";
export const FETCH_COUNTIES_FAILED = "FETCH_COUNTIES_FAILED";

export const FETCH_CURRENCIES = "FETCH_CURRENCIES";
export const FETCH_CURRENCIES_SUCCEEDED = "FETCH_CURRENCIES_SUCCEEDED";
export const FETCH_CURRENCIES_FAILED = "FETCH_CURRENCIES_FAILED";

export const FIND_ORGANIZATION = "FIND_ORGANIZATION";
export const FIND_ORGANIZATION_SUCCEEDED = "FIND_ORGANIZATION_SUCCEEDED";
export const FIND_ORGANIZATION_FAILED = "FIND_ORGANIZATION_FAILED";

export const CREATE_REQUEST = "CREATE_REQUEST";
export const CREATE_REQUEST_SUCCEEDED = "CREATE_REQUEST_SUCCEEDED";
export const CREATE_REQUEST_FAILED = "CREATE_REQUEST_FAILED";

export const REQUEST_DOCUMENTS = "REQUEST_DOCUMENTS";
export const REQUEST_DOCUMENTS_SUCCEEDED = "REQUEST_DOCUMENTS_SUCCEEDED";
export const REQUEST_DOCUMENTS_FAILED = "REQUEST_DOCUMENTS_FAILED";

export const REQUEST_DOCUMENTS_LIST = "REQUEST_DOCUMENTS_LIST";
export const REQUEST_DOCUMENTS_LIST_SUCCEEDED = "REQUEST_DOCUMENTS_LIST_SUCCEEDED";
export const REQUEST_DOCUMENTS_LIST_FAILED = "REQUEST_DOCUMENTS_LIST_FAILED";

export const REQUEST_NUMBER = "REQUEST_NUMBER";
export const REQUEST_NUMBER_SUCCEEDED = "REQUEST_NUMBER_SUCCEEDED";
export const REQUEST_NUMBER_FAILED = "REQUEST_NUMBER_FAILED";